const translations = {
    droneNameFieldPlaceholder: 'Drone Name',
    faaRegistrationNumberFieldPlaceholder: 'FAA Registration #'
};

export default translations;
